export default __webpack_public_path__ + "static/media/PROCESS_STEP2.7c3bedd5.png";